import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';

const FilterRadioGroup = ({
  selectedValue = '',
  fieldIndex,
  sectionIndex,
  onChangeFilterValue,
  options,
  source,
}) => {

  return (
    <Box display="flex" ml={2}>
      <RadioGroup
        row
        defaultValue={selectedValue}
        onChange={(event) => onChangeFilterValue({
          source,
          fieldIndex,
          sectionIndex,
          fieldValue: event.target.value,
        })}
      >
        {options?.map((opt) => (
          <FormControlLabel
            key={opt.value.toString()}
            value={String(opt.value)}
            control={<Radio size="small" />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default FilterRadioGroup;
